// extracted by mini-css-extract-plugin
export default {"timerText":"timer_timerText__E-Fwn"};